import React from 'react';
import { CTAButton } from './CTAButton';
export function FinalCTA() {
  return <section id="compra" className="w-full bg-white py-8 px-4 border-t-4 border-green-500" data-id="element-58">
      <div className="max-w-2xl mx-auto text-center" data-id="element-59">
        <h2 className="text-3xl md:text-4xl font-black text-black mb-8" data-id="element-60">
          📦 Todo lo que recibís hoy
        </h2>

        <ul className="text-left max-w-md mx-auto space-y-3 text-lg font-bold text-gray-800 mb-8" data-id="element-61">
          <li className="flex items-start" data-id="element-62">
            <span className="text-green-600 mr-3 flex-shrink-0" data-id="element-63">✓</span>
            Ebook Aprendizaje en Casa
          </li>
          <li className="flex items-start" data-id="element-64">
            <span className="text-green-600 mr-3 flex-shrink-0" data-id="element-65">✓</span>
            Bono 1: Lectura <span className="text-red-600 ml-1" data-id="element-66">(GRATIS)</span>
          </li>
          <li className="flex items-start" data-id="element-67">
            <span className="text-green-600 mr-3 flex-shrink-0" data-id="element-68">✓</span>
            Bono 2: Matemática{' '}
            <span className="text-red-600 ml-1" data-id="element-69">(GRATIS)</span>
          </li>
          <li className="flex items-start" data-id="element-70">
            <span className="text-green-600 mr-3 flex-shrink-0" data-id="element-71">✓</span>
            Bono 3: Cuentos <span className="text-red-600 ml-1" data-id="element-72">(GRATIS)</span>
          </li>
        </ul>

        <div className="flex justify-center gap-3 mb-8" data-id="element-73">
          <a href="#compra" data-id="element-74">
            <img src="https://cdn.magicpatterns.com/uploads/wKWLMw3KQnGVPp1oRAKSPb/imagen_principal_pagina.png" alt="Kit" className="w-20 h-auto object-contain" data-id="element-75" />
          </a>
          <a href="#compra" data-id="element-76">
            <img src="https://cdn.magicpatterns.com/uploads/sCFuecrYQeDo6TM9txg7M6/bonus_1.png" alt="Bonus 1" className="w-20 h-auto object-contain" data-id="element-77" />
          </a>
          <a href="#compra" data-id="element-78">
            <img src="https://cdn.magicpatterns.com/uploads/qavqcjyGgoE6QfHCL62grm/bonus_2.png" alt="Bonus 2" className="w-20 h-auto object-contain" data-id="element-79" />
          </a>
          <a href="#compra" data-id="element-80">
            <img src="https://cdn.magicpatterns.com/uploads/ggCb49yRFntMsjmrdGjAi4/bonus_3.png" alt="Bonus 3" className="w-20 h-auto object-contain" data-id="element-81" />
          </a>
        </div>

        <p className="text-base font-bold text-gray-500 mb-6" data-id="element-82">
          ✔ Acceso inmediato &nbsp;&nbsp; ✔ Un solo pago &nbsp;&nbsp; ✔
          Descarga digital &nbsp;&nbsp; ✔ Uso de por vida
        </p>

        <div className="mb-8" data-id="element-83">
          <p className="text-xl font-black text-red-600 uppercase tracking-widest mb-1" data-id="element-84">
            Precio Especial
          </p>
          <p className="text-5xl md:text-6xl font-black text-green-600" data-id="element-85">
            ARS $19.990
          </p>
        </div>

        <CTAButton text="SÍ, QUIERO ACCEDER AHORA" href="https://checkout.aulamater.online/cart/44071026851939:1" className="w-full mb-6" data-id="element-86" />

        <p className="text-sm text-gray-500 font-bold" data-id="element-87">
          🔒 Pago 100% Seguro y Encriptado
        </p>

        <div className="mt-10 text-sm text-gray-400" data-id="element-88">
          Este sitio no forma parte de Facebook ni está respaldado por Facebook
          Inc.
        </div>
      </div>
    </section>;
}